export type ParcelLineItem = {
  key: string;
  name: string;
  code?: string;
  qty: number;
  /** น้ำหนักต่อหน่วย (กรัม) */
  weightPerUnit?: number;
  /** ราคาต่อหน่วย (บาท) */
  pricePerUnit?: number;
};

export type ParcelProductDraft = {
  code?: string;
  name: string;
  qty: number;
  weightPerUnit?: number;
  pricePerUnit?: number;
};

/** ราคารวมต่อแถว = จำนวน × ราคาต่อหน่วย */
export function calcLineTotalPrice(
  qty: number,
  pricePerUnit?: number
): number | undefined {
  if (pricePerUnit == null) return undefined;
  return qty * pricePerUnit;
}

/** รวมน้ำหนักสินค้าจาก qty × น้ำหนักต่อหน่วย */
export function calcTotalProductWeightGrams(lines: ParcelLineItem[]): number {
  return lines.reduce(
    (sum, line) => sum + line.qty * (line.weightPerUnit ?? 0),
    0
  );
}
